// extracted by mini-css-extract-plugin
export default {"containerBlock":"NavigationDropDownStyles_containerBlock__rXycV","signoutText":"NavigationDropDownStyles_signoutText__mPW-z","profile":"NavigationDropDownStyles_profile__ttB+t"};